//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Entries from "./components/Entries.vue";
import Reports from "./components/Data-Visualization/Reports.vue";
import Home from "./components/Home.vue";
import SignIn_Login from "./components/Authentication/SignIn_Login.vue";
export default {
  name: "App",
  components: {
    Home,
    "signin-login": SignIn_Login,
    entries: Entries,
    reports: Reports,
  },
  data: function () {
    return {
      backendServerReady: false,
      signInActivator: false,
      loggedIn: false,
      spaViews: {
        home: true,
        entries: false,
        reports: false,
      },
    };
  },
  methods: {
    backendReadyForProcessing(value) {
      if (value) {
        this.backendServerReady = value;
       this.activateSignInDialog();
      }
    },
    activateSignInDialog() {
      this.signInActivator = !this.signInActivator;
    },
    loggedinView(value) {
      this.loggedIn = value;
    },
    loggedOut() {
      this.loggedIn = false;
      localStorage.clear();
      this.setHomeSpaView();
    },
    setEntriesSpaViewTarget() {
      if (this.loggedIn) {
        this.spaViews.entries = true;
        this.spaViews.home = false;
        this.spaViews.reports = false;
      }
    },
    setReportsSpaViewTarget() {
      if (this.loggedIn) {
        this.spaViews.entries = false;
        this.spaViews.home = false;
        this.spaViews.reports = true;
      }
    },
    setHomeSpaView() {
      this.spaViews.entries = false;
      this.spaViews.home = true;
      this.spaViews.reports = false;
    },
  },
};
